import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const Stopnice = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Stopnice"
          subtitle="Stopnice za eleganten vstop"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Stopnice"
            subtitle="Stopnice za eleganten vstop"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Kamnite stopnice združujejo estetsko dovršenost z izjemno trdnostjo in trajnostjo.
              Naravni kamen daje stopnicam eleganco in prestiž, hkrati pa zagotavlja varno in zanesljivo uporabo za desetletja.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Stopnice 1" },
              { src: "/placeholder.svg", alt: "Stopnice 2" },
              { src: "/placeholder.svg", alt: "Stopnice 3" },
              { src: "/placeholder.svg", alt: "Stopnice 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Stopnice;